// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.

export { log } from "./log.common.js";
